<template>
  <form-card
    labelText="Items"
  >
    <el-table
      :data="item"
    >
      <el-table-column
        align="center"
        prop="product_type"
        width="160"
        :label="getLabelText('', 'itemProductType')"
      >
        <template slot-scope="scope">
          {{ getOptName('itemProductType', scope.row.product_type) }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="service_type"
        width="200"
        :label="getLabelText('', 'itemServiceType')"
      >
        <template slot-scope="scope">
          {{ getOptName('itemServiceType', scope.row.service_type) }}
        </template>
      </el-table-column>
      <el-table-column
        align="right"
        prop="quantity"
        :label="getLabelText(itemBase, 'quantity')"
      >
      </el-table-column>
      <el-table-column
        align="right"
        prop="unit_price"
        :label="getLabelText(itemBase, 'unit_price')"
      >
      </el-table-column>
      <el-table-column
        align="right"
        prop="amount"
        :label="getLabelText(itemBase, 'amount')"
      >
      </el-table-column>
    </el-table>
  </form-card>
</template>

<script>
import { getLabelText, getOptName } from '@/utils/i18n'

export default {
  name: 'item-table',
  data () {
    return {
    }
  },
  props: {
    base: {
      type: String,
      required: true
    },
    item: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    itemBase () {
      return this.base + '.item'
    }
  },
  methods: {
    getLabelText,
    getOptName
  }
}
</script>
